
// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import {
//   BookmarkIcon,
//   LogIn,
//   Building2,
// } from "lucide-react";
// import {
//   Dialog,
//   DialogContent,
//   DialogDescription,
//   DialogHeader,
//   DialogTitle,
// } from "@/components/ui/dialog";
// import { Button } from "@/components/ui/button";
// import axios from "axios";

// function Lc({ job }) {
//   const navigate = useNavigate();
//   const [showAuthModal, setShowAuthModal] = useState(false);
//   const user = useSelector((state) => state.auth?.user);
//   const isAuthenticated = !!user;
//   const [isSaved, setIsSaved] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     const checkSavedStatus = async () => {
//       if (!isAuthenticated) return;

//       try {
//         const response = await axios.get(
//           `http://3.232.10.54/api/savedjobs/check/${job.jobId}`,
//           { withCredentials: true }
//         );
//         setIsSaved(response.data.isSaved);
//       } catch (error) {
//         console.error('Error checking saved status:', error);
//       }
//     };

//     checkSavedStatus();
//   }, [job.jobId, isAuthenticated]);

//   const handleSaveJob = async () => {
//     if (!isAuthenticated) {
//       setShowAuthModal(true);
//       return;
//     }

//     try {
//       setIsLoading(true);

//       if (!isSaved) {
//         await axios.post(
//           'http://3.232.10.54/api/savedjobs/save',
//           { jobId: job.jobId },
//           { withCredentials: true }
//         );
//         setIsSaved(true);
//       } else {
//         await axios.delete(
//           `http://3.232.10.54/api/savedjobs/unsave/${job.jobId}`,
//           { withCredentials: true }
//         );
//         setIsSaved(false);
//       }
//     } catch (error) {
//       console.error('Error saving/unsaving job:', error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleViewDescription = () => {
//     navigate(`/description/${job?.jobId}`);
//   };

//   return (
//     <>
//       <div
//         className="bg-white rounded-xl  border-gray-300 border-2 p-4 sm:p-6 shadow-sm hover:shadow-2xl transition-shadow cursor-pointer"
//         onClick={handleViewDescription}
//       >
//         {/* Top section: Logo, Title, Bookmark */}
//         <div className="flex justify-between items-start mb-4 sm:mb-5">
//           <div className="flex items-start gap-2 sm:gap-4">
//             {/* Company Logo */}
//             <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-md overflow-hidden bg-gray-50 flex items-center justify-center flex-shrink-0">
//               {job?.company?.logo ? (
//                 <img
//                   src={job?.company?.logo}
//                   alt={`${job?.company?.name || "Company"} logo`}
//                   className="w-full h-full object-contain"
//                 />
//               ) : (
//                 <Building2 className="w-8 h-8 sm:w-10 sm:h-10 text-gray-400" />
//               )}
//             </div>

//             {/* Company & Title */}
//             <div className="flex flex-col">
//               <span className="text-gray-500 text-sm sm:text-base mb-0.5 sm:mb-1">{job?.company?.CompanyName || "Company Name"}</span>
//               <h3 className="text-gray-800 text-lg sm:text-xl font-medium">{job?.title || "Job Title"}</h3>
//               {/* Location */}
//               <div className="flex items-center mt-1 sm:mt-2 text-blue-600">
//                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 sm:w-5 sm:h-5 mr-1">
//                   <path fillRule="evenodd" d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
//                 </svg>
//                 <span className="text-xs sm:text-sm">{job?.location || "Seattle"}</span>
//               </div>
//             </div>
//           </div>

//           {/* Bookmark Icon */}
//           <button
//             onClick={(e) => {
//               e.stopPropagation();
//               handleSaveJob();
//             }}
//             disabled={isLoading}
//             className={`text-blue-600 ${isLoading ? 'opacity-50' : ''}`}
//             aria-label={isSaved ? "Remove bookmark" : "Bookmark job"}
//           >
//             <BookmarkIcon
//               className={`w-5 h-5 sm:w-6 sm:h-6 ${isSaved ? 'text-blue-600 fill-blue-600' : 'text-blue-600'}`}
//             />
//           </button>
//         </div>

//         {/* Divider */}
//         <hr className="my-3 sm:my-5 border-gray-200" />

//         {/* Job Details Tags - Responsive */}
//         <div className="flex flex-wrap gap-2 sm:gap-3 mb-3 sm:mb-5">
//           <span className="bg-blue-50 text-gray-700 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm">{job?.experience}</span>
//           <span className="bg-blue-50 text-gray-700 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm">{job?.jobType}</span>
//           <span className="bg-blue-50 text-gray-700 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm">{job?.salary}</span>
//         </div>

//         {/* Job Description - Responsive */}
//         <p className="text-gray-500 text-xs sm:text-sm line-clamp-2">
//           {job?.description || "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit..."}
//         </p>
//       </div>

//       {/* Auth Modal - Keep unchanged but make sure it's mobile friendly */}
//       {!isAuthenticated && (
//         <Dialog open={showAuthModal} onOpenChange={setShowAuthModal}>
//           <DialogContent className="w-[90%] max-w-md mx-auto">
//             <DialogHeader>
//               <DialogTitle>Sign in Required</DialogTitle>
//               <DialogDescription>
//                 Please sign in to view job details and save jobs to your profile.
//               </DialogDescription>
//             </DialogHeader>
//             <div className="flex flex-col gap-4 py-4">
//               <p className="text-sm text-gray-500">
//                 Create an account or sign in to access all features and apply to
//                 jobs.
//               </p>
//               <div className="flex flex-col sm:flex-row justify-end gap-3">
//                 <Button
//                   variant="outline"
//                   className="w-full sm:w-auto"
//                   onClick={() => setShowAuthModal(false)}
//                 >
//                   Cancel
//                 </Button>
//                 <Button
//                   className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white"
//                   onClick={() => {
//                     setShowAuthModal(false);
//                     navigate("/signup/candidate");
//                   }}
//                 >
//                   <LogIn className="w-4 h-4 mr-2" />
//                   Sign Up
//                 </Button>
//               </div>
//             </div>
//             <div className="text-right mr-2">
//               <a
//                 className="text-xs cursor-pointer hover:text-blue-700 hover:underline"
//                 onClick={() => navigate('/login')}
//               >
//                 Already Registered?
//               </a>
//             </div>
//           </DialogContent>
//         </Dialog>
//       )}
//     </>
//   );
// }

// export default Lc;






// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import {
//   BookmarkIcon,
//   LogIn,
//   Building2,
// } from "lucide-react";
// import {
//   Dialog,
//   DialogContent,
//   DialogDescription,
//   DialogHeader,
//   DialogTitle,
// } from "@/components/ui/dialog";
// import { Button } from "@/components/ui/button";
// import axios from "axios";

// function Lc({ job }) {
//   const navigate = useNavigate();
//   const [showAuthModal, setShowAuthModal] = useState(false);
//   const user = useSelector((state) => state.auth?.user);
//   const isAuthenticated = !!user;
//   const [isSaved, setIsSaved] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     const checkSavedStatus = async () => {
//       if (!isAuthenticated) return;

//       try {
//         const response = await axios.get(
//           `http://3.232.10.54/api/savedjobs/check/${job.jobId}`,
//           { withCredentials: true }
//         );
//         setIsSaved(response.data.isSaved);
//       } catch (error) {
//         console.error('Error checking saved status:', error);
//       }
//     };

//     checkSavedStatus();
//   }, [job.jobId, isAuthenticated]);

//   const handleSaveJob = async () => {
//     if (!isAuthenticated) {
//       setShowAuthModal(true);
//       return;
//     }

//     try {
//       setIsLoading(true);

//       if (!isSaved) {
//         await axios.post(
//           'http://3.232.10.54/api/savedjobs/save',
//           { jobId: job.jobId },
//           { withCredentials: true }
//         );
//         setIsSaved(true);
//       } else {
//         await axios.delete(
//           `http://3.232.10.54/api/savedjobs/unsave/${job.jobId}`,
//           { withCredentials: true }
//         );
//         setIsSaved(false);
//       }
//     } catch (error) {
//       console.error('Error saving/unsaving job:', error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleViewDescription = () => {
//     navigate(`/description/${job?.jobId}`);
//   };

//   return (
//     <>
//       <div
//         className="bg-white rounded-xl border-gray-300 border-2 p-3 sm:p-4 shadow-sm hover:shadow-2xl transition-shadow cursor-pointer max-w-xs w-full"
//         onClick={handleViewDescription}
//       >
//         {/* Top section: Logo, Title, Bookmark */}
//         <div className="flex justify-between items-start mb-2 sm:mb-3">
//           <div className="flex items-start gap-2 sm:gap-3">
//             {/* Company Logo */}
//             <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-md overflow-hidden bg-gray-50 flex items-center justify-center flex-shrink-0">
//               {job?.company?.logo ? (
//                 <img
//                   src={job?.company?.logo}
//                   alt={`${job?.company?.name || "Company"} logo`}
//                   className="w-full h-full object-contain"
//                 />
//               ) : (
//                 <Building2 className="w-6 h-6 sm:w-7 sm:h-7 text-gray-400" />
//               )}
//             </div>

//             {/* Company & Title */}
//             <div className="flex flex-col">
//               <span className="text-gray-500 text-xs sm:text-sm mb-0.5">{job?.company?.CompanyName || "Company Name"}</span>
//               <h3 className="text-gray-800 text-base sm:text-lg font-medium">{job?.title || "Job Title"}</h3>
//               {/* Location or Remote */}
//               <div className="flex items-center mt-1 text-blue-600">
//                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-3 h-3 sm:w-4 sm:h-4 mr-1">
//                   <path fillRule="evenodd" d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
//                 </svg>
//                 <span className="text-xs sm:text-sm">{job?.jobType?.includes("Remote") ? "Remote" : (job?.location || "Location TBD")}</span>
//               </div>
//             </div>
//           </div>

//           {/* Bookmark Icon */}
//           <button
//             onClick={(e) => {
//               e.stopPropagation();
//               handleSaveJob();
//             }}
//             disabled={isLoading}
//             className={`text-blue-600 ${isLoading ? 'opacity-50' : ''}`}
//             aria-label={isSaved ? "Remove bookmark" : "Bookmark job"}
//           >
//             <BookmarkIcon
//               className={`w-4 h-4 sm:w-5 sm:h-5 ${isSaved ? 'text-blue-600 fill-blue-600' : 'text-blue-600'}`}
//             />
//           </button>
//         </div>

//         {/* Divider */}
//         <hr className="my-2 sm:my-3 border-gray-200" />

//         {/* Job Details Tags - Responsive */}
//         <div className="flex flex-wrap gap-1 sm:gap-2">
//           <span className="bg-blue-50 text-gray-700 px-2 py-1 sm:px-3 sm:py-1.5 rounded-full text-xs">{job?.experience}</span>
//           <span className="bg-blue-50 text-gray-700 px-2 py-1 sm:px-3 sm:py-1.5 rounded-full text-xs">{job?.jobType}</span>
//           <span className="bg-blue-50 text-gray-700 px-2 py-1 sm:px-3 sm:py-1.5 rounded-full text-xs">{job?.salary}</span>
//         </div>
//       </div>

//       {/* Auth Modal - Keep unchanged but make sure it's mobile friendly */}
//       {!isAuthenticated && (
//         <Dialog open={showAuthModal} onOpenChange={setShowAuthModal}>
//           <DialogContent className="w-[90%] max-w-md mx-auto">
//             <DialogHeader>
//               <DialogTitle>Sign in Required</DialogTitle>
//               <DialogDescription>
//                 Please sign in to view job details and save jobs to your profile.
//               </DialogDescription>
//             </DialogHeader>
//             <div className="flex flex-col gap-4 py-4">
//               <p className="text-sm text-gray-500">
//                 Create an account or sign in to access all features and apply to
//                 jobs.
//               </p>
//               <div className="flex flex-col sm:flex-row justify-end gap-3">
//                 <Button
//                   variant="outline"
//                   className="w-full sm:w-auto"
//                   onClick={() => setShowAuthModal(false)}
//                 >
//                   Cancel
//                 </Button>
//                 <Button
//                   className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white"
//                   onClick={() => {
//                     setShowAuthModal(false);
//                     navigate("/signup/candidate");
//                   }}
//                 >
//                   <LogIn className="w-4 h-4 mr-2" />
//                   Sign Up
//                 </Button>
//               </div>
//             </div>
//             <div className="text-right mr-2">
//               <a
//                 className="text-xs cursor-pointer hover:text-blue-700 hover:underline"
//                 onClick={() => navigate('/login')}
//               >
//                 Already Registered?
//               </a>
//             </div>
//           </DialogContent>
//         </Dialog>
//       )}
//     </>
//   );
// }

// export default Lc;


import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Briefcase, MapPin, DollarSign, Clock,
  CalendarDays, Bookmark, Eye, LogIn,
} from "lucide-react";
import {
  Dialog, DialogContent, DialogDescription,
  DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import axios from "axios";
import { SAVED_JOBS_API_END_POINT } from "@/utils/constant";
import { toast } from "sonner";

function timeAgo(dateString) {
  if (!dateString) return "";
  const now = new Date();
  const posted = new Date(dateString);
  const diffMs = now - posted;
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffDay > 30) return `${Math.floor(diffDay / 30)} month${Math.floor(diffDay / 30) > 1 ? "s" : ""} ago`;
  if (diffDay > 0) return `${diffDay} day${diffDay > 1 ? "s" : ""} ago`;
  if (diffHour > 0) return `${diffHour} hour${diffHour > 1 ? "s" : ""} ago`;
  if (diffMin > 0) return `${diffMin} minute${diffMin > 1 ? "s" : ""} ago`;
  return "Just now";
}

function Lc({ job }) {
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const user = useSelector((state) => state.auth?.user);
  const isAuthenticated = !!user;
  const [isSaved, setIsSaved] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  

  // ── Derived display values ──
  const title       = job?.title?.S       || job?.title       || "Untitled";
  const location    = job?.location?.S    || job?.location    || "";
  const jobType     = job?.jobType?.S     || job?.jobType     || "";
  const salary      = job?.salary?.S      || job?.salary      || "";
  const experience  = job?.experience?.S  || job?.experience  || "";
  const description = job?.description?.S || job?.description || "";
  const createdAt   = job?.createdAt?.S   || job?.createdAt   || "";

  const jobId = job?._id || job?.jobId?.S || job?.jobId;

  const companyName =
    job?.company?.CompanyName ||
    job?.company?.name ||
    job?.companyName?.S ||
    job?.companyName ||
    "Company";

  const companyLogo =
    job?.company?.logo ||
    job?.companyLogo?.S ||
    job?.companyLogo ||
    null;

  const initials = companyName
    .split(" ")
    .filter(Boolean)
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  const shortDesc =
    description.length > 130 ? description.slice(0, 130) + "..." : description;

  useEffect(() => {
    const checkSavedStatus = async () => {
      if (!isAuthenticated || !jobId) return;
      try {
        const response = await axios.get(
          `${SAVED_JOBS_API_END_POINT}/check/${jobId}`,
          { withCredentials: true }
        );
        setIsSaved(response.data.isSaved);
      } catch (error) {
        console.error("Error checking saved status:", error);
      }
    };
    checkSavedStatus();
  }, [jobId, isAuthenticated]);

  const handleSaveJob = async () => {
    if (!isAuthenticated) {
      setShowAuthModal(true);
      return;
    }
    try {
      setIsLoading(true);
      if (!isSaved) {
        await axios.post(
          `${SAVED_JOBS_API_END_POINT}/save`,
          { jobId },
          { withCredentials: true }
        );
        setIsSaved(true);
        toast.success("Job saved!");
      } else {
        await axios.delete(
          `${SAVED_JOBS_API_END_POINT}/unsave/${jobId}`,
          { withCredentials: true }
        );
        setIsSaved(false);
        toast.success("Job removed from saved");
      }
    } catch (error) {
      console.error("Error saving/unsaving job:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewDescription = () => {
    navigate(`/description/${jobId}`);
  };

  return (
    <>
      <div className="p-4 md:p-5 border border-gray-200 rounded-xl bg-white hover:shadow-md hover:border-[#012760] transition-all duration-200 cursor-pointer">

        {/* ── Top row: logo · title / company / location · time ago ── */}
        <div className="flex items-start gap-3">

          {/* Company logo / initials avatar */}
          <div className="flex-shrink-0 w-12 h-12 rounded-xl border border-gray-200 bg-[#EEF4FF] flex items-center justify-center overflow-hidden">
            {companyLogo ? (
              <img
                src={companyLogo}
                alt={companyName}
                className="w-full h-full object-contain p-1"
                onError={(e) => { e.currentTarget.style.display = "none"; }}
              />
            ) : (
              <span className="text-sm font-bold text-[#012760] select-none">{initials}</span>
            )}
          </div>

          {/* Title + company name + location */}
          <div className="flex-1 min-w-0">
            <p className="text-xs text-gray-500 mb-0.5 truncate">{companyName}</p>
            <h3 className="text-[15px] font-semibold text-[#012760] leading-snug line-clamp-1">{title}</h3>
            {location && (
              <div className="flex items-center gap-1 mt-1">
                <MapPin className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" />
                <span className="text-xs text-gray-500 truncate">{location}</span>
              </div>
            )}
          </div>

          {/* Time ago — top right */}
          {createdAt && (
            <div className="flex-shrink-0 flex items-center gap-1 text-xs text-gray-400 whitespace-nowrap">
              <CalendarDays className="w-3.5 h-3.5" />
              <span>{timeAgo(createdAt)}</span>
            </div>
          )}
        </div>

        {/* ── Divider ── */}
        <div className="my-3 border-t border-gray-100" />

        {/* ── Info pills ── */}
        <div className="flex flex-wrap items-center gap-2">
          {experience && (
            <div className="flex items-center gap-1.5 text-xs text-gray-600 bg-gray-50 border border-gray-200 rounded-md px-2.5 py-1.5">
              <Briefcase className="w-3.5 h-3.5 text-[#012760]" />
              <span>{experience}</span>
            </div>
          )}
          {salary && (
            <div className="flex items-center gap-1.5 text-xs text-gray-600 bg-gray-50 border border-gray-200 rounded-md px-2.5 py-1.5">
              <DollarSign className="w-3.5 h-3.5 text-[#012760]" />
              <span>{salary}</span>
            </div>
          )}
          {jobType && (
            <div className="flex items-center gap-1.5 text-xs text-blue-700 bg-blue-50 border border-blue-100 rounded-md px-2.5 py-1.5">
              <Clock className="w-3.5 h-3.5 text-blue-600" />
              <span>{jobType}</span>
            </div>
          )}
        </div>

        {/* ── Description snippet ── */}
        {shortDesc && (
          <p className="mt-3 text-xs text-gray-500 leading-relaxed line-clamp-2">{shortDesc}</p>
        )}

        {/* ── Action buttons ── */}
        <div className="mt-3 flex items-center gap-2 flex-wrap">

          {/* Save Job */}
          <button
            onClick={handleSaveJob}
            disabled={isLoading}
            className={`flex items-center gap-1.5 px-4 py-2 text-xs font-semibold rounded-lg border transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed
              ${isSaved
                ? "bg-[#EEF4FF] border-[#012760] text-[#012760]"
                : "bg-white border-gray-200 text-gray-500 hover:border-[#012760] hover:text-[#012760]"
              }`}
          >
            <Bookmark
              className="w-3.5 h-3.5"
              fill={isSaved ? "#012760" : "none"}
              stroke={isSaved ? "#012760" : "currentColor"}
            />
            {isLoading ? "..." : isSaved ? "Saved" : "Save Job"}
          </button>

          {/* View Details */}
          <button
            onClick={handleViewDescription}
            className="flex items-center gap-1.5 px-4 py-2 text-xs font-semibold rounded-lg border border-gray-200 bg-white text-gray-600 hover:border-[#012760] hover:text-[#012760] transition-all duration-200"
          >
            <Eye className="w-3.5 h-3.5" />
            View Details
          </button>

        </div>
      </div>

      {/* ── Auth Modal ── */}
      {!isAuthenticated && (
        <Dialog open={showAuthModal} onOpenChange={setShowAuthModal}>
          <DialogContent className="w-[90%] max-w-md mx-auto">
            <DialogHeader>
              <DialogTitle>Sign in Required</DialogTitle>
              <DialogDescription>
                Please sign in to view job details and save jobs to your profile.
              </DialogDescription>
            </DialogHeader>
            <div className="flex flex-col gap-4 py-4">
              <p className="text-sm text-gray-500">
                Create an account or sign in to access all features and apply to jobs.
              </p>
              <div className="flex flex-col sm:flex-row justify-end gap-3">
                <Button
                  variant="outline"
                  className="w-full sm:w-auto"
                  onClick={() => setShowAuthModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white"
                  onClick={() => {
                    setShowAuthModal(false);
                    navigate("/signup/candidate");
                  }}
                >
                  <LogIn className="w-4 h-4 mr-2" />
                  Sign Up
                </Button>
              </div>
            </div>
            <div className="text-right mr-2">
              <a
                className="text-xs cursor-pointer hover:text-blue-700 hover:underline"
                onClick={() => navigate("/login")}
              >
                Already Registered?
              </a>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}

export default Lc;
